import { useEffect, useRef } from "react";
import { getAdsConsent } from "@/components/AdsConsentBanner";

const CLIENT = "ca-pub-9086862190837952";

const loadScript = () => {
  if (getAdsConsent() !== "granted") (window.adsbygoogle = window.adsbygoogle || []).requestNonPersonalizedAds = 1;
  if (document.querySelector(`script[src*="adsbygoogle.js"]`)) return;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
  document.head.appendChild(s);
};

export const AdSlot = ({ slot, testid = "adsense-slot" }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!getAdsConsent()) return;
    loadScript();
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch { /* blocker */ }
  }, []);
  return (
    <div className="px-6 py-4 [&:has(ins[data-ad-status=unfilled])]:hidden" data-testid={testid}>
      <p className="text-[10px] uppercase tracking-wide text-gray-400 mb-1">Pubblicità</p>
      <ins ref={ref} className="adsbygoogle block min-h-[100px] rounded-xl bg-gray-50" style={{ display: "block" }}
        data-ad-client={CLIENT} data-ad-slot={slot || undefined} data-ad-format="auto" data-full-width-responsive="true" />
    </div>
  );
};
